/* Cart-drawer — openen/sluiten, aantallen, verwijderen, toevoegen vanuit "You may also like".
   Na elke mutatie wordt de sectie opnieuw opgehaald (Section Rendering API), zodat prijzen,
   kortingsstaffel en aanbevelingen door Liquid worden berekend en niet in JS worden nagebouwd. */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root) return;

  var body = root.querySelector('[data-cd-body]');
  var busy = false;

  /* ── openen / sluiten ── */
  /* 30-10: page behind the drawer must not scroll — iOS Safari ignores overflow:hidden on body,
     so pin the body with position:fixed and restore the exact scroll spot on close */
  var lockedY = null;
  function lockScroll() {
    if (lockedY !== null) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    var st = document.body.style;
    st.position = 'fixed'; st.top = (-lockedY) + 'px'; st.left = '0'; st.right = '0'; st.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (lockedY === null) return;
    var st = document.body.style, y = lockedY; lockedY = null;
    st.position = ''; st.top = ''; st.left = ''; st.right = ''; st.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, y);
  }

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-open');
    lockScroll();
    var close = root.querySelector('[data-cd-close]');
    if (close) close.focus();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-open');
    unlockScroll();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cd-open], a[href="/cart"], a[href$="/cart"]');
    if (trigger && !trigger.hasAttribute('data-cd-ignore')) {
      e.preventDefault();
      refresh().then(function () { open(); protSync(); });
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]') || e.target.classList.contains('cd-scrim')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* ── sectie opnieuw renderen ── */
  function refresh() {
    /* 26-08: de lade zit nu in sectiegroep 'cart-group' zodat hij in de theme editor
       staat. Daardoor is het sectie-id dynamisch — Liquid zet het in data-section-id. */
    var el = root.querySelector('.drawer.cd');
    var sid = (el && el.getAttribute('data-section-id')) || 'cart-drawer';
    return fetch('/?section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer.cd');
        if (fresh && body) {
          body.innerHTML = fresh.outerHTML;
          syncCount(fresh.getAttribute('data-cart-count'));
        }
      })
      .catch(function () { /* netwerkfout: drawer laat gewoon de vorige stand zien */ });
  }

  function syncCount(n) {
    document.querySelectorAll('.count, [data-cart-count-bubble]').forEach(function (el) {
      if (el.closest('#cart-drawer')) return;
      el.textContent = n;
    });
  }

  /* ── cart-mutaties ── */
  function post(url, payload) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'cart error');
        return refresh();
      })
      .catch(function (err) {
        var note = root.querySelector('[data-cd-error]');
        if (note) { note.textContent = err.message; note.hidden = false; }
      })
      .then(function () { busy = false; protSync(); });
  }

  root.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      var line = qty.getAttribute('data-cd-qty');
      var to = parseInt(qty.getAttribute('data-to'), 10);
      var row = qty.closest('.item');
      if (row) row.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(line, 10), quantity: Math.max(0, to) });
      return;
    }

    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      var row2 = rm.closest('.item');
      if (row2) row2.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(rm.getAttribute('data-cd-remove'), 10), quantity: 0 });
      return;
    }

    var add = e.target.closest('[data-cd-add]');
    if (add) {
      var card = add.closest('[data-cd-rec]');
      var picker = card && card.querySelector('[data-cd-variant]');
      if (!picker || !picker.value) return;
      add.disabled = true;
      post('/cart/add.js', { items: [{ id: parseInt(picker.value, 10), quantity: 1 }] });
      return;
    }

    var prev = e.target.closest('[data-cd-prev]');
    var next = e.target.closest('[data-cd-next]');
    if (prev || next) {
      var track = root.querySelector('[data-cd-track]');
      if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    }
  });

  /* 24-10 Order protection: toggle, default-on (setting), remove when cart only holds protection */
  function protSync() {
    var st = root.querySelector('[data-prot-state]');
    if (!st || busy) return;
    var line = parseInt(st.getAttribute('data-line'), 10) || 0;
    var count = parseInt(st.getAttribute('data-count'), 10) || 0;
    if (count === 0 && line > 0) { post('/cart/change.js', { line: line, quantity: 0 }); return; }
    var box = root.querySelector('[data-prot-variant]');
    if (!box || line > 0 || count === 0) return;
    var off = false; try { off = sessionStorage.getItem('protOff') === '1'; } catch (e) {}
    if (box.getAttribute('data-prot-default') === '1' && !off) {
      post('/cart/add.js', { items: [{ id: parseInt(box.getAttribute('data-prot-variant'), 10), quantity: 1 }] });
    }
  }
  root.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-prot-toggle]');
    if (!tg) return;
    var box = tg.closest('[data-prot-variant]');
    var vid = parseInt(box.getAttribute('data-prot-variant'), 10);
    var on = tg.getAttribute('aria-checked') === 'true';
    tg.setAttribute('aria-checked', String(!on));
    try { if (on) sessionStorage.setItem('protOff', '1'); else sessionStorage.removeItem('protOff'); } catch (err) {}
    if (on) post('/cart/change.js', { id: String(vid), quantity: 0 });
    else post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] });
  });
  /* 24-10: protection switch on the /cart page (outside the drawer) -> mutate, then reload */
  document.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-prot-toggle]');
    if (!tg || tg.closest('#cart-drawer')) return;
    var box = tg.closest('[data-prot-variant]');
    var vid = parseInt(box.getAttribute('data-prot-variant'), 10);
    var on = tg.getAttribute('aria-checked') === 'true';
    tg.setAttribute('aria-checked', String(!on));
    try { if (on) sessionStorage.setItem('protOff', '1'); else sessionStorage.removeItem('protOff'); } catch (err) {}
    var req = on ? { url: '/cart/change.js', body: { id: String(vid), quantity: 0 } } : { url: '/cart/add.js', body: { items: [{ id: vid, quantity: 1 }] } };
    fetch(req.url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(req.body) })
      .then(function () { location.reload(); });
  });

  /* ── openen na 'add to cart' elders op de pagina ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    busy = false;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function () { return refresh(); })
      .then(function () { open(); protSync(); })
      .catch(function () { form.submit(); });
  });

  /* ?cart=open → drawer meteen tonen (handig na een redirect) */
  if (new URLSearchParams(location.search).get('cart') === 'open') {
    refresh().then(open);
  }
})();
